import Axios from '@/components/api/axios.js'
//电梯监控接口
export default {
	/**
	 * 电梯信息列表
	 */
	list(pageSize, pageIndex, success, failure) {
		Axios.get('/elevatorInfo/list.do', {pageSize, pageIndex}, success, failure)
	},
	/**
	 * 通过id获取电梯信息
	 */
	getElevatorInfo(id, success, failure) {
		Axios.get('/elevatorInfo/getElevatorInfo.do', {id}, success, failure)
	},
	/**
	 * 保存/更新电梯信息
	 * id 为空则是添加 不为空则是修改
	 */
	saveElevatorInfo(elevatorId,elevatorName,elevatorUrl,id, success, failure) {
		Axios.post('/elevatorInfo/saveElevatorInfo.do', {elevatorId,
			elevatorName,
			elevatorUrl,
			id
		}, success, failure)
	},
	/**
	 * 通过id删除电梯信息
	 */
	deleteElevatorInfo(id, success, failure) {
		Axios.get('/elevatorInfo/deleteElevatorInfo.do', {id}, success, failure)
	},
	editDevice(pkid, deviceName, ip, port, userName, password, type, videoUrl, sort, success, failure) {
		Axios.post('/video/editDevice.do', {
			pkid,
			deviceName,
			ip,
			port,
			userName,
			password,
			type,
			videoUrl,
			sort,
		}, success, failure);
	},
	deleteDevice(pkid, unitId, success, failure) {
		Axios.post('/video/deleteDevice.do', {
			pkid,
			unitId,
		}, success, failure);
	},
	searchByUnitId(unitId, success, failure) {
		Axios.post('/video/searchByUnitId.do', {
			unitId,
		}, success, failure);
	},
	/**
	 *	绑定台账设备
	 */
	bindArchives(videoDeviceId, archivesId, success, failure) {
		Axios.post('/video/bindArchives.do', {
			videoDeviceId,
			archivesId
		}, success, failure);
	},
	/**
	 *	解绑 
	 */
	unbingArchvies(relationId, success, failure) {
		Axios.post('/video/unbingArchvies.do', {
			relationId
		}, success, failure);
	},
	/**
	 * 查询摄像头的关联的设备
	 * type传unit是绑定的单位   传archives是台账设备
	 */
	findRelation(videoDeviceId, type, success, failure) {
		Axios.post('/video/findRelation.do', {
			videoDeviceId,
			type
		}, success, failure);
	},

}